import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dramatic%20and%20artistic%20illustration%20featuring%20Korean%20manhwa%20style%20characters%20in%20dynamic%20poses%20with%20flowing%20ink%20effects%2C%20warm%20gradient%20background%20from%20deep%20crimson%20to%20dark%20charcoal%2C%20abstract%20comic%20panel%20lines%20scattered%20artistically%2C%20Japanese%20and%20Korean%20comic%20art%20aesthetic%2C%20dramatic%20lighting%20with%20golden%20accents%2C%20cinematic%20composition%2C%20high%20contrast%2C%20digital%20art%20masterpiece&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
          alt="爱漫画 - 韩国漫画在线阅读"
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-32 md:py-40">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          <div className="flex-1 text-center lg:text-left">
            <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-black text-background-50 leading-tight">
              韩国漫画
              <br />
              <span className="text-primary-400">无删减</span>下拉式
              <br />
              免费韩漫大全
            </h1>
            <p className="mt-6 text-lg md:text-xl text-background-200/90 max-w-lg mx-auto lg:mx-0 leading-relaxed">
              爱漫画汇聚优质韩国漫画资源，每日上新、更新不断。下拉式阅读畅快体验，无需翻页，丝滑到底。
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Link
                to="/category/action"
                className="whitespace-nowrap px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all cursor-pointer text-center"
              >
                开始阅读
              </Link>
              <Link
                to="/about"
                className="whitespace-nowrap px-8 py-3.5 rounded-full border-2 border-background-50/40 text-background-50 text-base font-medium hover:bg-background-50/10 transition-all cursor-pointer text-center"
              >
                了解更多
              </Link>
            </div>

            <div className="mt-12 flex items-center gap-8 justify-center lg:justify-start">
              <div className="text-center">
                <p className="font-heading text-3xl md:text-4xl font-bold text-background-50">2000+</p>
                <p className="text-sm text-background-300 mt-1">漫画资源</p>
              </div>
              <div className="w-px h-10 bg-background-50/20"></div>
              <div className="text-center">
                <p className="font-heading text-3xl md:text-4xl font-bold text-background-50">500万+</p>
                <p className="text-sm text-background-300 mt-1">忠实读者</p>
              </div>
              <div className="w-px h-10 bg-background-50/20"></div>
              <div className="text-center">
                <p className="font-heading text-3xl md:text-4xl font-bold text-background-50">每日</p>
                <p className="text-sm text-background-300 mt-1">持续更新</p>
              </div>
            </div>
          </div>

          <div className="hidden lg:flex flex-1 justify-center">
            <div className="relative w-72 md:w-80 aspect-[3/4] rounded-lg overflow-hidden border-2 border-background-50/20">
              <img
                src="https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20manhwa%20style%20cover%20art%20illustration%20of%20a%20powerful%20male%20protagonist%20with%20dark%20hair%20and%20intense%20eyes%2C%20wearing%20traditional%20martial%20arts%20robes%2C%20surrounded%20by%20golden%20energy%20aura%2C%20dramatic%20composition%20with%20dynamic%20brush%20strokes%2C%20rich%20warm%20colors%20with%20crimson%20and%20gold%20tones%2C%20high%20quality%20digital%20art%2C%20simple%20dark%20background%20with%20golden%20accents&width=720&height=960&seq=hero-featured-comic&orientation=portrait"
                alt="热门韩漫推荐"
                className="w-full h-full object-cover"
                loading="eager"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-5">
                <p className="text-background-50 font-heading text-lg font-bold">东皇传</p>
                <p className="text-background-300 text-sm mt-1">本周最热 · 评分 9.7</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}